<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase>
  <div id="mainBody" #mainBody class="showcase-body">
    <table class="bordered-table" style="width: 65%;">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetSiteInfo()"><i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Site Information</td>
            </tr>
          </table>
        </th>
      </tr>
      <tr>
        <td>Name:</td>
        <td *ngIf="site != null">{{site.siteName}}</td>
        <td>Code:</td>
        <td *ngIf="site != null">{{site.siteCode}}</td>
        <td>Active:</td>
        <td *ngIf="site != null">{{site.isActive}}</td>
      </tr>
    </table>
    <table id="tableSiteMileage" #tableSiteMileage class="bordered-table"
           *ngIf="site?.siteId!=undefined && site?.siteId!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="AddSiteMileage()"><i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetSiteInfo()"><i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Site Mileage</td>
            </tr>
          </table>
        </th>
      </tr>
      <tr *ngFor="let sm of sitesMileage; let i = index;" class="data-table-row">
        <td>
          <button class="btn btn-xs btn-primary" (click)="deleteSiteBaseMileage(sm.siteBaseMileageId, i)"><i
            class="fa fa-trash"></i></button>
        </td>
        <td><label>Year: <input class="modelo-text-input" type="text" [(ngModel)]="sm.year"
                                (change)="updateSitesIndexes(i)" maxlength="4"></label></td>
        <td><label>Million Miles Per Year: <input class="modelo-text-input" type="text" [(ngModel)]="sm.mileage"
                                                  (change)="updateSitesIndexes(i)"></label></td>
      </tr>
    </table>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" (click)="saveChanges()"><i
    class="fa fa-save"></i>&nbsp;Save
  </button>&nbsp;
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
</div>
